<template>
  <div>
    <div>
      <div v-if="loaded && adminLives.length === 0">
        <div class="alert alert-primary" role="alert">
          در این تاریخ پخشی یافت نشد.
        </div>
      </div>
    </div>
    <div>
      <b-row align-v="center" align-h="between">
        <b-col
          align-v="center"
          align-h="between"
          sm="12"
          lg="4"
          class="mt-2 mb-3"
        >
          <date-picker
            type="date"
            v-model="searchDate"
            name="start"
            format="YYYY-MM-DD HH:mm:ss"
            display-format="HH:mm jYYYY/jMM/jDD"
            color="#1e1f22"
            label="تاریخ شروع"
            class="date-picker-style"
          />
        </b-col>
        <b-col
          align-v="center"
          align-h="between"
          sm="6"
          lg="4"
          class="mt-2 mb-3"
        >
          <button
            type="button"
            class="btn btn-primary"
            title="جستجو"
            @click="getLives"
            :disabled="!searchDate"
          >
            <i class="fal fa-search pt-1" />
            جستجو
          </button></b-col
        >
        <b-col
          align-v="center"
          align-h="between"
          sm="6"
          lg="4"
          class="d-flex justify-content-end mb-1"
        >
          <div>
            <span class="badge bg-secondary text-white font-size-sm">
              تعداد پخش ها :
              <span dir="ltr" class="font-size-sm text-white">
                {{ numberFormat(adminLivesPagination.total) }}
              </span>
            </span>
          </div></b-col
        >
      </b-row>
    </div>
    <div v-show="fLives.length" class="card card-custom gutter-b">
      <div class="card-header min-h-50px">
        <div class="card-title">
          <h3 class="card-label">آخرین پخش ها</h3>
        </div>
      </div>
      <div class="card-body">
        <div class="table-responsive">
          <table
            class="table table-head-custom table-head-bg table-borderless table-vertical-center"
          >
            <thead>
              <tr>
                <th>عنوان</th>
                <th>کاربر</th>
                <th>شروع</th>
                <th>پایان</th>
                <th>مدت</th>
                <th>وضعیت</th>
                <th>عملیات</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="li in fLives" :key="li.id">
                <td class="text-nowrap">
                  <span class="label" :class="li.labelClass">
                    <span class="position-relative" v-html="li.icon"></span>
                    <span class="pulse-ring"></span>
                  </span>
                  {{ li.name }}
                </td>
                <td>
                  <router-link
                    :to="{
                      name: 'company-users-show',
                      params: { id: li.user?.id }
                    }"
                  >
                    {{ gFullName(li.user) }}
                  </router-link>
                </td>
                <td>
                  <span dir="ltr" class="text-nowrap">
                    {{ formatDate(li.start) }}
                  </span>
                </td>
                <td dir="ltr" class="text-nowrap">
                  {{ formatDate(li.end) }}
                </td>
                <td dir="ltr">{{ li.length }}</td>
                <td dir="ltr" class="text-nowrap">
                  <span
                    v-if="li.labelClass == 'pulse pulse-danger label-danger'"
                    class="font-family-base"
                    >درحال پخش</span
                  >
                  <span
                    v-if="li.labelClass == 'label-warning'"
                    class="font-family-base"
                    >پایان لینک یا استریم ورودی</span
                  >
                  <span
                    v-if="li.labelClass == 'label-danger'"
                    class="font-family-base"
                    >خطا</span
                  >
                  <span
                    v-if="li.labelClass == 'label-primary'"
                    class="font-family-base"
                    >موفق</span
                  >
                </td>
                <td>
                  <router-link
                    :to="{
                      name: 'admin-programs-show',
                      params: { id: li.program_id }
                    }"
                    class="btn btn-xs btn-primary"
                  >
                    مشاهده
                  </router-link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          class="overflow-auto mt-5"
          v-if="adminLivesPagination.lastPage > 1"
        >
          <b-pagination
            v-model="adminLivesPagination.currentPage"
            :total-rows="adminLivesPagination.total"
            :per-page="adminLivesPagination.perPage"
            aria-controls="my-table"
            @input="getLives()"
          ></b-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.vpd-icon-btn {
  margin-bottom: 0;
}
</style>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import { SET_ACTIONS } from "@/core/services/store/actions.module";
import { mapGetters } from "vuex";
import {
  FETCH_ADMIN_LIVES,
  SET_ADMIN_LIVES
} from "@/core/services/store/admin/lives.module";

let d = new Date();
d.setMonth(d.getMonth() - 1);
d.setHours(0, 0, 0, 0);

export default {
  name: "adminLives",
  data() {
    return {
      loaded: false,
      searchDate: this.prettyDate(new Date(d)),
      labels: {
        0: "pulse pulse-danger label-danger",
        1: "label-warning",
        2: "label-danger",
        3: "label-primary",
        4: "label-warning"
      },
      icons: {
        0: '<i class="far fa-1x fa-play pt-1 text-white"></i>', //started
        1: '<i class="far fa-1x fa-circle pt-1 text-white"></i>', //finished
        2: '<i class="far fa-1x fa-exclamation pt-1 text-white"></i>', //failed
        3: '<i class="far fa-1x fa-stop pt-1 text-white"></i>', //stopped by user
        4: '<i class="far fa-1x fa-stop pt-1 text-white"></i>' //stopped by company
      }
    };
  },
  components: {
    datePicker: VuePersianDatetimePicker
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "مدیریت",
        route: { name: "admin-dashboard" }
      },
      { title: "پخش ها" }
    ]);
    this.$store.dispatch(SET_ACTIONS, {});
    this.getLives();
  },
  computed: {
    ...mapGetters([
      "currentUserProperty",
      "adminLives",
      "adminLivesPagination"
    ]),
    fLives() {
      let data = [];
      this.adminLives.forEach(live => {
        let end = undefined,
          labelClass = this.labels[0],
          length = "-",
          error = "",
          icon = this.icons[0];
        if (live.events !== undefined) {
          if (live.events[0] !== undefined) {
            end = live.events[0].created_at ?? undefined;
            length = live.events[0].details.length
              ? this.prettyTime(live.events[0].details.length)
              : "-";
            error = live.events[0].details.error ?? "";
            labelClass = this.labels[live.events[0].type];
            icon = this.icons[live.events[0].type];
          } else {
            length = this.prettyTime(this.getDuration(live.created_at));
          }
        } else {
          length = this.prettyTime(this.getDuration(live.created_at));
        }
        data.push({
          name: live.program?.name,
          id: live.id,
          user: live.program?.user,
          program_id: live.program_id,
          start: live.created_at,
          end: end,
          labelClass: labelClass,
          length: length,
          error: error,
          icon: icon
        });
      });
      return data;
    }
  },
  methods: {
    getLives() {
      this.livesLoaded = false;
      this.$store.commit(SET_ADMIN_LIVES, []);
      this.$store
        .dispatch(FETCH_ADMIN_LIVES, {
          from: this.searchDate
        })
        .then(() => {
          this.livesLoaded = true;
        })
        .catch(() => {
          this.livesLoaded = true;
        });
    }
  }
};
</script>
